import script from "./UpgradeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts&setup=true"

import "./UpgradeModal.vue?vue&type=style&index=0&id=6c861870&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c861870"]])

export default __exports__